<template>
  <div>
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>User Phones</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            show-select
            v-model="selected"
            :items="userPhones"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0 black--text"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <!-- <v-list-item link>
                    <v-list-item-title @click="edit(item.id)">
                      Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)">
                      Delete
                    </v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ parseInt(item.amount, 10).toFixed(2) }}
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
export default {
  props: {
    payload: {
      from: 0,
      to: 10,
      userId: null
    }
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Phone",
          align: "left",
          sortable: false,
          value: "phone"
        },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    userPhones() {
      return this.$store.state.userphones.userPhones;
    },
    totalItems() {
      return this.$store.state.userphones.total;
    }
  },
  created() {
    this.getUserPhones(this.payload);
  },
  methods: {
    filterName(value) {
      this.payload.name = value;
      this.getUserPhones(this.payload);
    },
    filterApproved(value) {
      this.payload.approved = value;
      this.getUserPhones(this.payload);
    },
    getUserPhones(payload) {
      this.loading = true;
      console.log(payload);
      this.$store
        .dispatch("userphones/LOAD_USER_PHONES", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getUserPhones(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        this.getUserPhones(this.payload);
      }
    }
  }
};
</script>
<style lang="scss">
#users {
  .filters {
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
